import React from 'react';
import { useTranslation } from 'react-i18next';

import RichText, { ParsedTypes } from '@/components/RichText';
import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';
import { RichTextField } from '@prismicio/client';

export const DetailsSection = ({ details, title }: { details: RichTextField; title?: string | null }) => {
    const { t } = useTranslation('promohub');
    return (
        <>
            <Text variant={'headlineMedium'} lineHeight={28} color={ds.colorToken.text.primary} paddingBottom={'s16'}>
                {title ?? t('details')}
            </Text>
            <RichText
                data={details}
                typeProps={{
                    [ParsedTypes.P]: {
                        textAlign: 'left',
                        color: ds.colorToken.text.primary,
                        variant: 'bodyMedium',
                    },
                }}
            />
        </>
    );
};
